export const FontFamily = 'Urbanist, Roboto, Helvetica, Arial, sans-serif';

type Typography = {
  FontFamily: string;
  FontSize: number;
  FontWeight: FontWeight;
  LineHeight: number;
};

function getFontDefinition(
  fontWeight: FontWeight,
  fontSize: number,
  lineHeight: number
): Typography {
  return {
    FontFamily: FontFamily,
    FontSize: fontSize,
    FontWeight: fontWeight,
    LineHeight: lineHeight,
  };
}

export enum FontWeight {
  Thin = 100,
  ExtraLight = 200,
  Light = 300,
  Regular = 400,
  Medium = 500,
  SemiBold = 600,
  Bold = 700,
  ExtraBold = 800,
  Heavy = 900,
}

export const Size = {
  HugeTitleBold: getFontDefinition(FontWeight.ExtraBold, 64, 72),
  HugeTitle: getFontDefinition(FontWeight.SemiBold, 64, 88),
  LargeTitle: getFontDefinition(FontWeight.ExtraBold, 48, 64),
  DisplayLarge: getFontDefinition(FontWeight.ExtraBold, 36, 48),
  DisplayMedium: getFontDefinition(FontWeight.Bold, 28, 32),
  DisplaySmall: getFontDefinition(FontWeight.Bold, 20, 28),
  Heading: getFontDefinition(FontWeight.Bold, 18, 24),
  SubHeading: getFontDefinition(FontWeight.Bold, 16, 24),
  BodyLargeHeavy: getFontDefinition(FontWeight.SemiBold, 16, 24),
  BodyLarge: getFontDefinition(FontWeight.Regular, 16, 24),
  BodyHeavy: getFontDefinition(FontWeight.Bold, 14, 22),
  Body: getFontDefinition(FontWeight.SemiBold, 14, 22),
  SmallHeavy: getFontDefinition(FontWeight.Bold, 12, 20),
  Small: getFontDefinition(FontWeight.SemiBold, 12, 20),
  Badge: getFontDefinition(FontWeight.Medium, 8, 12),
};

export type FontSize = keyof typeof Size;
